import { EventMeta, hasMeta } from '@/utils/events.utils'
import ActionButton from '@/app/_components/ActionButton/ActionButton'
import { ReactNode } from 'react'
import TXT from '@/messages'

type Props = {
  eventOnSale: boolean
  meta: EventMeta
}

const ExternalUrlActionButton = ({ meta, eventOnSale } : Props): ReactNode => {
  const externalUrl = hasMeta('externalTicketUrl', meta)
    && meta.externalTicketUrl

  const externalButtonText = hasMeta('externalBtnTxt', meta)
    ? meta.externalBtnTxt
    : TXT.eventsPage.buyTickets

  if (!externalUrl) {
    return null
  }

  return (
    <ActionButton
      className="external-link"
      buttonText={externalButtonText}
      disabled={!eventOnSale}
      as="a"
      size="sm"
      href={externalUrl}
    />
  )
}

export default ExternalUrlActionButton
